"use client";

import styles from "@/styles/home/recommend-list.module.scss";
import { useState, useEffect } from "react";
import ProductItem from "@/components/global/ProductItem";
import featuredSectionApi from "@/service/modules/featuredSectionApi"
import { ProductType } from '@/types/product';
import { Button } from "react-vant";

export default function NotFoundLoadMore() {
  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize] = useState(10)
  const [pagelist, setPageList] = useState<ProductType[]>([])
  const [loading, setLoading] = useState(false)
  const [isFinsh, setIsFinsh] = useState(false)

  useEffect(() => {
    setLoading(true)
    getTopSellerList()
  }, [currentPage, pageSize])

  const getTopSellerList = async () => {
    try {
      const params: any = {
        page: currentPage,
        perPage: pageSize
      }
      const res = await featuredSectionApi.getSectionList("top-seller", params)
      setPageList([...pagelist, ...res.data.pageList.items])
      setLoading(false)
      setIsFinsh(res.data.pageList.items.length < pageSize)
    } catch (error) {
      console.log(error)
    }
  }

  return (
    <div 
      className={styles["comp-recommend-list"]}
      style={{ paddingTop: "20px", background: "#EDEDED" }}
    >

      {
        pagelist.length > 0 && (
          <div className={styles["recommend-list"]}>
            {pagelist.map((product: ProductType) => (
              <div className={styles["recommend-item"]} key={product.productID}>
                <ProductItem product={product} />
              </div>
            ))}
          </div>
        )
      }
      
      {
        !isFinsh && pagelist.length > 0
        &&
        <Button
          round
          type="primary"
          block
          onClick={() => {
            setCurrentPage(currentPage + 1)
          }}
          loading={loading}
          loadingText={`View more >`}
          style={{ width: "60%", margin: "16px auto", fontWeight: "700" }}
        >View more {'>'}</Button>
      }
    </div>
  );
}
